import { render, staticRenderFns } from "./JcAdd.vue?vue&type=template&id=9c8e8dce&"
import script from "./JcAdd.vue?vue&type=script&lang=js&"
export * from "./JcAdd.vue?vue&type=script&lang=js&"
import style0 from "./JcAdd.vue?vue&type=style&index=0&id=9c8e8dce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports